<div class="grid grid-cols-2 gap-2">
  @for (config of orderedActions(); track config.action) {
    <button
      [disabled]="!config.enabled"
      [ngClass]="[config.style, config.fullWidth === false ? '' : 'col-span-2']"
      [attr.data-testId]="config.testId"
      [pTooltip]="config.enabled ? '' : config.tooltip"
      (click)="onAction(config)"
      class="flx-ds small"
      tooltipStyleClass="text-xs"
      variant="ghost"
      flxButton
      icon="left"
    >
      {{ config.label }}
      @if (config.icon) {
        <i
          [class]="config.icon"
          flxIcon
        ></i>
      }
    </button>
  }

  @if (!applicationVersion().hasContent) {
    <div class="text-neutral-400 text-xs col-span-2">
      Version is not available on current environment
    </div>
  }
</div>
